if(!customElements.get('overlay-injector')){
    class OverlayInjector extends HTMLElement {
        constructor() {
            super();
            
            this.IsOpen = false;
            this.OpenButton = this.querySelector('[data-opener]')
            this.OverlayTarget = this.OpenButton.dataset.overlayTarget || 'GenericLayer'
            this.Content = this.querySelector('.Content')


            this.OpenButton.addEventListener('click', () => {
                this.OpenContent()
            })
        }

OpenContent() {
  const ContentCopy = this.Content.cloneNode(true)

  // Ensure cloned overlay content is visible
  ContentCopy.style.removeProperty('display')
  ContentCopy.style.removeProperty('visibility')
  ContentCopy.removeAttribute('hidden')

  theme?.Overlay?.InjectLayer(`#${this.OverlayTarget}`, ContentCopy)
  theme?.Overlay?.ActivateLayer(`${this.OverlayTarget}`)
}


    }
    customElements.define('overlay-injector', OverlayInjector);
}